module.exports = __webpack_public_path__ + "static/media/earth.954f8c3e.svg";